/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Card } from 'antd';
import CreateTemplateFighthing from 'components/TemplateFighthing/templateFighthing.create';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const TemplateFighthingCreatePage = () => {
   const location = useLocation();
   const locationSplit = location?.pathname.split('/');
   let id = null;
   if (location?.pathname.includes('edit')) {
      id = Number(locationSplit[4]);
   }

   return (
      <Fragment>
         <Helmet>
            <title>{id ? 'แก้ไขข้อมูลเทมเพลตตั้งสู้' : 'สร้างข้อมูลเทมเพลตตั้งสู้' }</title>
         </Helmet>
         <HasAccess
            roles={['Owner','Senior','Master','Agent']}
            permissions={['payrate-create']}
            renderAuthFailed={<ErrorPage404 />}
         >
            <Card title={`${id ? 'แก้ไขข้อมูลเทมเพลตตั้งสู้' : 'สร้างข้อมูลเทมเพลตตั้งสู้' }`}>
               <CreateTemplateFighthing id={Number(id)}/>
            </Card>
         </HasAccess>
      </Fragment>
   );
};

export default TemplateFighthingCreatePage;
